import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

const CallCircleBlue = ({ color }) => (
  <Svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <Circle cx={12} cy={12} r={12} fill={color || "#2195F2"} />
    <Path
      d="M11.022 12.845c-1.019-1.02-1.249-2.038-1.301-2.447a.366.366 0 0 1 .105-.306l.825-.825a.368.368 0 0 0 .052-.455L9.39 6.772a.368.368 0 0 0-.477-.133l-2.108.992a.366.366 0 0 0-.203.366c.11 1.05.568 3.63 3.103 6.164 2.535 2.536 5.114 2.993 6.164 3.103a.366.366 0 0 0 .366-.202l.993-2.108a.368.368 0 0 0-.134-.477l-2.039-1.312a.368.368 0 0 0-.455.051l-.825.825a.366.366 0 0 1-.306.105c-.408-.052-1.428-.282-2.447-1.301Z"
      fill="#fff"
    />
  </Svg>
);

export default CallCircleBlue;
